import React from "react";
import { useNavigate } from "react-router-dom";
import LandingHero from "../components/Common/LandingHero";
import LeftRightImgContent from "../components/Common/LeftRightImgContent";
import BuildTogether from "../components/Home/BuildTogetherSection";
import DigitalInnovation from "../components/Home/DigitalInnovation";
import WhyAvexa from "../components/Home/WhyAvexa";
import Outcomes from "../components/Home/outcomes";
import CTASection from "../components/Common/CtaSection";
import TopBottomImgContent from "../components/Common/TopBottomImgContent";
import HeadernDescription from "../components/Common/HeadernDescription";
import { Link } from "react-router-dom";
import data from "../content.json";

const {
  hero,
  keyServices1,
  keyServices2,
  keyServices3,
  keyServices4,
  keyServices5,
  callToAction,
  keyServices2HeadingPara,
  keyServices1HeadingPara,
  sec6HeadingPara,
  sec7HeadingPara,
  keyServices7,
  keyServices8,
  sec8HeadingPara,
  keyServices6,
  sec5HeadingPara,
  sec9HeadingPara,
  sec10HeadingPara,
  keyServices9,
  keyServices10,
} = data.sections;
const Home = () => {
  const navigate = useNavigate();

  const handleScheduleDemo = () => {
    navigate("/get-in-touch?purpose=Platform Demo");
  };

  const handlePlatform = () => {
    navigate("/digital-health-platform");
  };

  const handleSolutions = () => {
    navigate("/digital-transformation");
  };

  const items = [
    {
      icon: "/assets/home/door.svg",
      text: "Engagement and digital front door",
    },
    {
      icon: "/assets/home/delivery.svg",
      text: "Clinical workflows and care delivery",
    },
    { icon: "/assets/home/doc.svg", text: "Engagement and digital front door" },
    {
      icon: "/assets/home/graph.svg",
      text: "Advanced analytics and intelligence",
    },
  ];

  return (
    <>
      <LandingHero data={data.sections.hero} />
      <div className="px-3 md:px-3 lg:px-0">
        {/* second section */}
        <div className="w-full md:pt-24">
          <div className="px-2 lg:px-6">
            <HeadernDescription
              section={keyServices1HeadingPara}
              align="left"
              // paddingY="py-10"
            ></HeadernDescription>
            <DigitalInnovation
              section={keyServices1}
              columns={5}
              arrowIcon={true}
              cardHeight="5vh"
              imgHeight="20vh"
            />
          </div>
          <div className="pt-[4vh] pb-[6vh]">
            <div className="flex justify-end gap-[2vw]">
              <p className="rounded-l-md text-center text-normalmb-[3vh] bg-[#132573] text-[#FFFFFF] px-[2vw] md:px-[3.5vw] py-[0.8vh] md:py-[2vh]">
                More technology—but less coordination.
              </p>
            </div>
          </div>
        </div>

        {/* third section */}
        <div className="w-full">
          <div className="px-2 lg:px-6 md:py-12">
            <HeadernDescription
              section={keyServices2HeadingPara}
              align="center"
              paddingY="py-4"
            ></HeadernDescription>
            <div className="container mx-auto lg:px-32">
              <DigitalInnovation
                section={keyServices2}
                columns={4}
                arrowIcon={false}
                cardHeight="5vh"
                imgHeight="20vh"
              />
            </div>
          </div>
        </div>

        {/* 4th Section */}
        <div className={`flex flex-col text-center py-10`}>
          <h2
            className="font-bold mb-3"
            style={{
              color: "var(--primary-color)",
              fontSize: "clamp(1.5rem, 2.4vw, 2.6rem)",
            }}
          >
            Building <br />
            Unified Intelligent Platforms
          </h2>
          <h4 style={{ color: "var(--primary-color)" }} className="py-4">
            -for a Connected Care Ecosystem
          </h4>

          <div className="lg:max-w-[55vw] text-center mx-auto">
            <p
              className="mb-[4vh] md:mb-[6vh]  mt-4 "
              style={{ color: "var(--primary-color)" }}
            >
              Avexa Systems creates Unified Intelligence Platforms that connect
              healthcare ecosystems—bringing care delivery organizations,
              managed care organizations, managed service organizations and
              partners onto a single, intelligent foundation for coordinated
              care and better outcomes.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-4 w-full sm:w-auto">
            <Link to="/one-care">
              <button className="btn btn-primary">Explore Avexa OneCare</button>
            </Link>
            <Link to="/get-in-touch#contactForm">
              <button className="btn btn-secondary">Book a Demo</button>
            </Link>
          </div>
          <hr className="w-full md:w-72 h-[0.2vh] md:h-[0.15vh] bg-[#13257317] border-0 mt-9 mx-auto " />
        </div>

        {/* 5th Section */}
        <div className="flex flex-col text-center py-5 bg-light ">
          {/* Mobile = Grid | MD+ = Flex Row */}
          <div
            className="grid grid-cols-[24px_1fr] gap-x-3 gap-y-3 max-w-[90%] mx-auto items-center
                  md:flex md:flex-wrap md:justify-center md:items-center md:gap-4"
          >
            {items.map((item, i) => (
              <div
                key={i}
                className="contents md:flex md:items-center md:gap-2"
              >
                {/* Icon */}
                <div className="flex justify-center items-center md:w-auto">
                  <img
                    src={item.icon}
                    className="w-4 h-4 md:w-5 md:h-5 object-contain"
                  />
                </div>

                {/* Text */}
                <span
                  className="  text-left md:text-center"
                  style={{ color: "var(--primary-color)" }}
                >
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* 6th Section */}
        <div className="w-full md:py-12">
          <div className="md:px-2 lg:px-6">
            <HeadernDescription
              section={sec6HeadingPara}
              align="center"
              paddingY="py-5"
            ></HeadernDescription>

            <LeftRightImgContent
              section={keyServices6}
              columns={2}
              align="center"
            />
          </div>
        </div>

        {/* 7th Section */}
        <div className="w-full">
          <div className="px-2 lg:px-6">
            <HeadernDescription
              section={sec7HeadingPara}
              align="left"
              paddingY="md:pt-10"
            ></HeadernDescription>
            <DigitalInnovation
              section={keyServices7}
              columns={4}
              arrowIcon="true"
              cardHeight="33vh"
              imgHeight="30vh"
            />
          </div>
        </div>

        {/* 8th Section */}
        <div className="w-full py-9 md:py-10">
          <div className="px-2 lg:px-6">
            <HeadernDescription
              section={sec8HeadingPara}
              align="left"
              paddingY="py-4"
            ></HeadernDescription>
            <DigitalInnovation
              section={keyServices8}
              columns={4}
              arrowIcon={false}
              bgColor="#F9FAFF"
              cardHeight="16vh"
              imgHeight="30vh"
            />
            <div className="flex justify-center mt-10">
              <Link to="/digital-health">
                <button className="btn btn-primary">
                  Explore Our Solutions
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* 9th Section */}
        <div className="w-full lg:py-10">
          <div className="px-2 md:px-14">
            <HeadernDescription
              section={sec9HeadingPara}
              align="center"
            ></HeadernDescription>
            <TopBottomImgContent
              section={keyServices9}
              imgHeight="20vh"
              cardHeight="20vh"
            ></TopBottomImgContent>
          </div>
        </div>

        {/* 10th Section */}
        <div className="w-full lg:py-10 bg-[#F9FAFF]">
          <div className="px-6 xl:px-16">
            <HeadernDescription
              section={sec10HeadingPara}
              align="center"
              paddingY="py-2"
            ></HeadernDescription>
            <Outcomes section={keyServices10} columns={4} arrowIcon={true} />
          </div>
        </div>

        {/* 11th Section */}
        <div className="w-full lg:py-10">
          <div className="px-2 lg:px-6">
            <HeadernDescription
              section={sec5HeadingPara}
              align="center"
              paddingY="pt-8"
            ></HeadernDescription>
            <div className="hidden xl:flex w-full justify-center">
              <img src="/assets/home/process2.png" alt="process" />
            </div>

            <DigitalInnovation
              section={keyServices5}
              columns={4}
              arrowIcon={false}
              cardHeight="20vh"
            />
          </div>
        </div>

        <BuildTogether />
      </div>
    </>
  );
};

export default Home;
